const _answerDate = Symbol();
const _value = Symbol();

const coalesce = (...args) => args.find(v => v !== undefined);

export class PainResponse {
	constructor(answerDate, value) {
		this.answerDate = answerDate;
		this.value = value;
	}
	get answerDate() {
		return this[_answerDate];
	}
	set answerDate(v) {
		if(!Number.isInteger(v))
			throw new TypeError('answerDate must be an integer.');
		this[_answerDate] = v;
	}
	get value() {
		return this[_value];
	}
	set value(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('value must be an integer.');
		this[_value] = v;
	}
	toJSON() {
		return {
			answerDate: this.answerDate,
			value: this.value
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		return new this(
			coalesce(obj.answerDate, obj.AnswerDate, null),
			coalesce(obj.value, obj.Value, null)
		);
	}
}